module.exports = __webpack_public_path__ + "img/gallery-frame01.4f2829ac.png";